module.exports = __webpack_public_path__ + "img/P4-2.e93ab7c9.jpg";